
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","viewBox":"0 0 36 36","fill":"#fff","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"4.95","y":"16.264","width":"26","height":"4","rx":"2"}}),_c('rect',{attrs:{"x":"15.828","y":"31.385","width":"26","height":"4","rx":"2","transform":"rotate(-90 15.828 31.385)"}})])
          )
        }
      }
    